import { useTheme } from '@mui/material';

export const ConveyorBelt = () => {
    const theme = useTheme();

    return (
        <svg width="500" height="150" viewBox="0 0 600 150" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <pattern id="treadPattern" x="0" y="0" width="30" height="20" patternUnits="userSpaceOnUse">
                    <circle cx="5" cy="10" r="5" fill={theme.palette.grey[600]} />
                </pattern>
                <style>
                    {`
                        @keyframes scrollTreads {
                            from { transform: translateX(-30px); }
                            to { transform: translateX(30px); }
                        }
                        #treadLayer {
                            animation: scrollTreads 1s linear infinite;
                        }
                        @keyframes moveBox {
                            from { transform: translateX(-60px); }
                            to { transform: translateX(600px); }
                        }
                        #box {
                            animation: moveBox 11s linear infinite;
                        }
                    `}
                </style>
            </defs>

            {/* Conveyor Belt Base */}
            <rect x="0" y="100" width="600" height="20" fill={theme.palette.grey[800]} />

            {/* Tread layer using pattern */}
            <rect id="treadLayer" x="0" y="100" width="600" height="20" fill="url(#treadPattern)" />

            {/* Moving Box */}
            <rect id="box" x="0" y="70" width="40" height="30" fill={theme.palette.secondary.main} rx="4" ry="4" />
        </svg>
    );
};

interface LoadingSpinnerProps {
    size?: number;
    color?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    size = 45,
    color
}) => {
    const theme = useTheme();
    const spinnerColor = color || theme.palette.primary.main;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            style={{
                margin: 'auto',
                background: theme.palette.background.default,
                display: 'block',
                shapeRendering: 'auto'
            }}
            width={`${size}px`}
            height={`${size}px`}
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
        >
            <rect x="17.5" y="30" width="15" height="40" fill={spinnerColor}>
                <animate
                    attributeName="y"
                    repeatCount="indefinite"
                    dur="1s"
                    calcMode="spline"
                    keyTimes="0;0.5;1"
                    values="18;30;30"
                    keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
                    begin="-0.2s"
                />
                <animate
                    attributeName="height"
                    repeatCount="indefinite"
                    dur="1s"
                    calcMode="spline"
                    keyTimes="0;0.5;1"
                    values="64;40;40"
                    keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
                    begin="-0.2s"
                />
            </rect>
            <rect x="42.5" y="30" width="15" height="40" fill={spinnerColor}>
                <animate
                    attributeName="y"
                    repeatCount="indefinite"
                    dur="1s"
                    calcMode="spline"
                    keyTimes="0;0.5;1"
                    values="20.999999999999996;30;30"
                    keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
                    begin="-0.1s"
                />
                <animate
                    attributeName="height"
                    repeatCount="indefinite"
                    dur="1s"
                    calcMode="spline"
                    keyTimes="0;0.5;1"
                    values="58.00000000000001;40;40"
                    keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
                    begin="-0.1s"
                />
            </rect>
            <rect x="67.5" y="30" width="15" height="40" fill={spinnerColor}>
                <animate
                    attributeName="y"
                    repeatCount="indefinite"
                    dur="1s"
                    calcMode="spline"
                    keyTimes="0;0.5;1"
                    values="20.999999999999996;30;30"
                    keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
                />
                <animate
                    attributeName="height"
                    repeatCount="indefinite"
                    dur="1s"
                    calcMode="spline"
                    keyTimes="0;0.5;1"
                    values="58.00000000000001;40;40"
                    keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
                />
            </rect>
        </svg>
    );
}; 